export const azureQueryKeys = {
  getMetadataApplicationGateways: (params: {
    teamId: string
    subscriptionId: string
  }) => ['azure/metadata/application-gateways', params] as const,
  getMetadataAuthorization: (teamId: string) =>
    ['azure/metadata/authorization', { teamId }] as const
}
